import { isValidElement } from 'react';
import { graphql } from '@apollo/client/react/hoc';
// Components
import { Redirect } from 'react-router';
import Loader from 'components/Loader';
import PayrollDownAlert from 'components/PayrollDownAlert';
// GraphQL
import * as Queries from 'apollo/queries';

const withPayrollStatusProtection = (options = {}) => Component => {
  let { fallback: Fallback, fallbackRoute, alertProps = {} } = options || {};
  const C = props => {
    const {
      data: { loading, getServiceAccessTest } = {},
      classes: { alertClassName } = {},
    } = props || {};
    if (loading) return <Loader />;
    if (getServiceAccessTest) return <Component {...props} />;

    if (Fallback !== undefined && isValidElement(<Fallback />))
      return <Fallback {...props} />;
    if (typeof fallbackRoute === 'string')
      return <Redirect push exact to={fallbackRoute} />;
    return <PayrollDownAlert className={alertClassName} {...alertProps} />;
  };

  C.displayName = `withPayrollStatusProtection(${Component.displayName ||
    Component.name})`;

  return graphql(Queries.GetServiceStatus)(C);
};

export default withPayrollStatusProtection;
